module.exports = __webpack_public_path__ + "static/media/WarningIcon.a8d22d2b.svg";